<template>
  <el-dialog
    :inline = "true"
    width="60%"
    :title="$t('noLoginApplyDialog.application_information')"
    :visible.sync="visible"
    @close="close">

    <el-form :model="applyForm" label-position="left" label-width="135px">

      <el-form-item :label="`${$t('noLoginApplyDialog.id')}:`" v-if="false">
        <el-input size="mini" v-model="applyForm.id" autocomplete="off" :disabled="true"  v-if="false"></el-input>
      </el-form-item>
      <el-form-item :label="`${$t('noLoginApplyDialog.ogs_id')}:`">
        <el-input size="mini" v-model="applyForm.ogs_id" autocomplete="off" :disabled="true"></el-input>
      </el-form-item>
      <el-form-item :label="`${$t('noLoginApplyDialog.level')}:`" v-if="checkboxview">
        <el-checkbox-group v-model="checklist"> 
          <el-checkbox label="1L" v-if="is1L"></el-checkbox>
          <el-checkbox label="15L" v-if="is15L">1.5L</el-checkbox>
          <el-checkbox label="2L" v-if="is2L"></el-checkbox>
        </el-checkbox-group>
      </el-form-item>

      <el-form-item :label="`${$t('noLoginApplyDialog.remark')}*:`">
        <el-input size="mini" v-model="applyForm.remark" autocomplete="off" ></el-input>
      </el-form-item>

      <el-form-item :label="`${$t('noLoginApplyDialog.name')}*:`">
        <el-input size="mini" v-model="applyForm.name" autocomplete="off"></el-input>
      </el-form-item>

      <el-form-item :label="`${$t('noLoginApplyDialog.applyemail')}*:`">
        <el-input size="mini" v-model="applyForm.applyemail" autocomplete="off"></el-input>
      </el-form-item>

      <el-form-item :label="`${$t('noLoginApplyDialog.applycop')}*:`">
        <el-input size="mini" v-model="applyForm.applycop" autocomplete="off"></el-input>
      </el-form-item>

    </el-form>
    <div class="divcss5">
      数据下载链接将发送到您的邮箱!(The data download link will be sent to your email address!)
    </div>

    <div slot="footer" class="dialog-footer">
      <el-button size="mini" @click="close">{{$t('noLoginApplyDialog.cancel')}}</el-button>
      <el-button size="mini" type="primary" @click="ok">{{$t('noLoginApplyDialog.ok')}}</el-button>
    </div>

  </el-dialog>
</template>

<script>
export default {
  props: {
    dialogVisible: {
      type: Boolean,
      default: false,
    },
    dialogType: {
      type: String,
      default: '',
    },
    dialogData: {
      type: Object,
      default(){
        return null
      },
    },
  },
  data() {
    return {
      applyForm: {
        id: '',
        obs_id: '',
        grb_id: '',
        sem_id: '',
        name: '',
        remark:'',
        applyemail: '',
        applycop: '',
        level:'',
      },
      is1L:false,
      is15L:false,
      is2L:false,
      checklist:[],
      visible: false,
      tabletype:'',
      checkboxview: false,
    };
  },
  watch: {
    dialogVisible(val) {
      this.visible = val;
    },
    dialogType(val){
      this.tabletype = val;
    },
    dialogData(data){
      // console.log('传入的数据',data);
      if(this.tabletype==='OBS'){
        this.checklist = [];
        this.is1L = data.is1L;
        this.is15L = data.is15L;
        this.is2L = data.is2L;
        this.applyForm.id = data.id;
        this.applyForm.ogs_id = data.obs_id;
        if(this.is1L){this.checklist.push('1L');}
        if(this.is15L){this.checklist.push('15L');}
        if(this.is2L){this.checklist.push('2L');}
        // console.log('Checkbox内容',this.checklist);
        this.checkboxview = true;
      }else if(this.tabletype==='GRB'){
        this.applyForm.id = data.ind;
        this.applyForm.ogs_id = data.grb_id;
        this.checklist = [];
      }else if(this.tabletype==='SEM'){
        this.applyForm.id = data.ind;
        this.applyForm.ogs_id = data.sem_id;
        this.checklist = [];
      }
    },
  },
  methods: {
    close() {
      this.$emit('close');
    },
    ok() {
      if(this.checkboxview && this.checklist.length ===0){
        this.$alert(this.$t('noLoginApplyDialog.messinfo.select_datalevel'), '提示(Tips)', {
          confirmButtonText: '确定(Ok)',
          callback: action => {
            this.$message({
              type: 'warning',
              message: `action: ${ action }`
            });
          }
        });
        return;
      }
      // var regEmail = /^[A-Za-z0-9\u4e00-\u9fa5]+@[a-zA-Z0-9_-]+(\.[a-zA-Z0-9_-]+)+$/;
      var regEmail = /^[A-Za-z0-9\u4e00-\u9fa5]+([-_.][A-Za-zd]+)*@[a-zA-Z0-9_-]+(\.[a-zA-Z0-9_-]+)+$/;
      if(this.applyForm.applyemail != '' && !regEmail.test(this.applyForm.applyemail)){
        this.$alert(this.$t('noLoginApplyDialog.messinfo.mailbox_detection'), '提示(Tips)', {
          confirmButtonText: '确定(Ok)',
          callback: action => {
            this.$message({
              type: 'warning',
              message: `action: ${ action }`
            });
          }
        });
        return;

      }
      if(this.applyForm.name ==='' || this.applyForm.remark ==='' || this.applyForm.applyemail ==='' || this.applyForm.applycop ===''){
        this.$alert(this.$t('noLoginApplyDialog.messinfo.lack_information'), '提示(Tips)', {
          confirmButtonText: '确定(Ok)',
          callback: action => {
            this.$message({
              type: 'warning',
              message: `action: ${ action }`
            });
          }
        });
        return;
      }

      this.applyForm.level = this.checklist.join();
      this.$emit('ok', {
        ...this.applyForm,
      });
    },
  }
}
</script>

<style lang="scss" scoped>

.divcss5{
  padding-top: 8px;
  padding-bottom: 8px;
  text-align:center;
  font-size: 14px;
  color: #1d1e20;
} 
</style>